import styled, { css } from 'styled-components';
import { mobile_xl, tablet } from '../../../../global/mediaQueryMixin';
import { FlexCenter, HideScrollbar } from '../../../../global/commonStyle';

interface Props {
  applyScrolling?: boolean;
  isKeyboardVisible?: boolean;
}

const OuterDiv = styled.div<Props>`
  position: relative;
  width: 100%;
  height: 100dvh;
  background-color: var(--background-secondary);
  overflow: hidden;
  ${mobile_xl(css<Props>`
    height: ${({ isKeyboardVisible }) => (isKeyboardVisible ? '100dvh' : '')};
    ${HideScrollbar}
  `)}
`;

const Icon = styled.div`
  position: absolute;
  top: 20px;
  padding: var(--space-8);
  cursor: pointer;
  ${FlexCenter}
  border-radius: var(--border-radius-8);
  &:hover {
    background-color: var(--neutral-secondary);
    svg path {
      fill: var(--text-primary);
    }
  }
  &.closeIcon {
    right: 20px;
  }
  &.backIcon {
    left: 20px;
  }
  ${mobile_xl(css`
    position: unset;
    padding: var(--space-6);
    svg {
      width: 20px;
      height: 20px;
    }
  `)}
`;

const MainSection = styled.div`
  max-width: 1280px;
  margin: var(--space-0) auto;
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: var(--space-40);
  overflow: visible;
  padding-top: var(--space-80);
  height: 100%;
  padding-inline: var(--space-40);
  ${tablet(css`
    position: relative;
    left: unset;
    padding-inline: var(--space-0);
  `)}
  ${mobile_xl(css`
    padding-top: var(--space-0);
  `)}
`;

export { OuterDiv, Icon, MainSection };
